import { render, staticRenderFns } from "./BarraAcesso.vue?vue&type=template&id=56eacaaf&"
import script from "./BarraAcesso.vue?vue&type=script&lang=js&"
export * from "./BarraAcesso.vue?vue&type=script&lang=js&"
import style0 from "./BarraAcesso.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports